<template>
	<div class="content ai" v-show="ctx.state.sidebarTab == 'ai'">
		<AiChat />
	</div>
</template>

<script>
// The AI chat sidebar panel. v-show rather than v-if, so the conversation
// survives switching to another tab and back - as it did when this lived in
// EntryEditor.
//
// This is also where the entry-editing toolset is exposed to the assistant. It
// used to be registered by EntryEditor in every environment, including the ones
// with no assistant to use it; now it exists exactly where the chat does.
import AiChat from '@/ai/AiChat.vue'
import { registerTools, unregisterTools } from '@/ai/toolRegistry'
import { entryToolset } from '@/ai/tools/entry'
import { aiSelector } from './selector'

export const extension = {
	...aiSelector,
	type: 'EntryEditor',
	location: 'sidebar',
}

export default {
	name: 'AiPanel',
	components: { AiChat },
	props: { ctx: Object },
	data: () => ({ toolsToken: null }),
	mounted() {
		this.toolsToken = registerTools(entryToolset(this.ctx.state.entryApi), this.ctx.state.entryApi)
	},
	beforeDestroy() {
		if (this.toolsToken != null) unregisterTools(this.toolsToken)
	},
}
</script>

<style scoped>
/* EntryEditor's scoped `.content` / `.sidebar .content` rules cannot reach into an
   extension, so the panel now carries the geometry it used to inherit from the
   host - including the padding:0 / height overrides it had inline there. */
.content.ai { display: flex; flex-direction: column; gap: 30px; flex: 1; overflow-y: auto; padding: 0; height: calc(100% - 40px); transform: translate(0, 0); }
/* was `.sidebar > .content > div` in the host */
.content.ai > * { gap: 13px; color: rgb(90, 101, 124); margin-top: 5px; }
</style>
